const onFailure = (error) => ({
  message: 'Categoria de transação já cadastrada!',
  type: 'warning',
});

export default onFailure;
